import customAxios from "../../customAxios";
import { ADMIN_GET_COMPANY_DEPOSITE } from "../../routes";

const getCompanyDeposite = async (_id: string, endAt?: string): Promise<any> => {
  const thisUrl: string = ADMIN_GET_COMPANY_DEPOSITE + '/' + _id + `?endAt=${endAt ? new Date(endAt).toISOString() : new Date().toISOString()}`;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_GET_COMPANY_DEPOSITE: error });
  }
};

export default getCompanyDeposite;
